import _ from 'lodash';
import { CountryMap } from "wni-common-sources";

const {
    COUNTRY_FORMAT_MAPS
} = CountryMap;

const DEFAULT_COUNTRY = 'US';

const getPostalCodeReg = (country = DEFAULT_COUNTRY) => {
    const formatByCountry = COUNTRY_FORMAT_MAPS[country];
    return formatByCountry.regex
}

// eslint-disable-next-line default-param-last
const isPostalCodeValid = (country = DEFAULT_COUNTRY, postalCode) => {
    const formatByCountry = COUNTRY_FORMAT_MAPS[country];
    if(!formatByCountry) {
        return true;
    }
    const { regex } = formatByCountry;
    return regex.test(postalCode)
};

// eslint-disable-next-line default-param-last
const postalCodeFormat = (country = DEFAULT_COUNTRY, postalCode) => {
    const formatByCountry = COUNTRY_FORMAT_MAPS[country];
    if(!formatByCountry) {
        return postalCode;
    }

    const { formatPostalCode } = formatByCountry;
    if(!formatPostalCode) {
        return postalCode;
    }
    return formatPostalCode(postalCode);
}

const getPostalCodeLabel = (country = DEFAULT_COUNTRY) => {
    const countryItem = COUNTRY_FORMAT_MAPS[country];
    return _.get(countryItem, 'postalCode', 'Zip Code')
}

export default {
    getPostalCodeReg,
    isPostalCodeValid,
    postalCodeFormat,
    getPostalCodeLabel
}